import { render, staticRenderFns } from "./RedirectRulesForm.vue?vue&type=template&id=070495bb"
import script from "./RedirectRulesForm.vue?vue&type=script&lang=js"
export * from "./RedirectRulesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('070495bb')) {
      api.createRecord('070495bb', component.options)
    } else {
      api.reload('070495bb', component.options)
    }
    module.hot.accept("./RedirectRulesForm.vue?vue&type=template&id=070495bb", function () {
      api.rerender('070495bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/redirect-rules-form/RedirectRulesForm.vue"
export default component.exports